// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/produkte/montageset-fuer-dialysegeraete/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteMontagesetFuerDialysegeraeteDE: PageEntry = {
  id: "example.produkte-montageset-fuer-dialysegeraete",
  locale: "de",
  slug: "produkte/montageset-fuer-dialysegeraete",
  seo: {
    title: "Montageset für Dialysegeräte | Dietz GmbH",
    description: "Feder aus Tantaldraht als Funktionselement im Dialysegerät Druckfedern werden einer 100% Prüfung unterzogen und anschließen durch einer Montage mit den Kunststoffkomponenten montie",
  },
  type: "post",
  h1: "Montageset für Dialysegeräte",
  intro: "Feder aus Tantaldraht als Funktionselement im Dialysegerät Druckfedern werden einer 100% Prüfung unterzogen und anschließen durch einer Montage mit den Kunststoffkomponenten montiert. Um die spätere Montage in den Geräten zu vereinfachen werden Montagesets bei Dietz zusammengestellt.",
  blocks: [
    { kind: "image", src: "/images/live/dtz-montagesetzDialyse.jpg", alt: "Montageset für Dialysegeräte", width: 1400, height: 1120 }
  ],
};
